// components
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';

// utils
import { formatNumber } from '@makemydeal/dr-common-utils';

type MilesOdometerProps = {
    mileage: string | number;
};

export const MilesOdometer = ({ mileage }: MilesOdometerProps) => {
    const mileageValue = typeof mileage === 'string' ? Number(mileage) : mileage;
    const isValid = mileage !== '' && mileage != null && !isNaN(mileageValue);

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            <Typography variant="body-md" color="sem.color.on-surface.muted" tag="span">
                Miles/Odo:
            </Typography>
            <Typography variant="body-md" tag="span">
                {isValid ? formatNumber(mileageValue) : '—'}
            </Typography>
        </Box>
    );
};
